import { kebabCase, filter, flatten, map, size } from 'lodash';
import { calculateBmi } from 'utils';

export const decorateMember = member => {
  // Ensure startWeightInKg & height is null when 0 so forms validate.
  const height = member.profile.height
    ? parseFloat(member.profile.height)
    : null;

  const startWeightInKg = member.startWeightInKg
    ? parseFloat(member.startWeightInKg)
    : null;

  // Add the members bmi
  const bmi = calculateBmi(startWeightInKg, height);

  // Ensure subscription step is a Number
  const subscriptions = map(member.subscriptions, item => {
    const step = parseInt(item.step, 10);

    return {
      ...item,
      slug: kebabCase(item.title),
      // If user has multiple subscriptions, then skip profile welcome step
      step: size(member.subscriptions) > 1 && step === 1 ? 2 : step,
    };
  });

  // Create a simple list of active preferences
  const isActive = item => filter(item, 'active');
  const isActivePreference = items => flatten(map(items, isActive));
  const preferenceNames = member.voomeProfile
    ? map(isActivePreference(member.voomeProfile.preferences), 'name')
    : [];

  return {
    ...member,
    startWeightInKg,
    bmi,
    subscriptions,
    profile: {
      ...member.profile,
      height,
    },
    voomeProfile: {
      ...member.voomeProfile,
      preferenceNames,
    },
  };
};



// WEBPACK FOOTER //
// ./src/decorators/decorateMember.js